import React, {Component} from  "react";
import {Row, Col, Tabs, Input, Spin } from 'antd';
import {connect} from 'react-redux';
// import cookie from "react-cookies";
import { getVerticalBrushPanel, getC240CanvasComponent, getStainChooser, getSpeedPanel } from "../c240_slot_component_utils";
import { scanTypeVals } from '../../../utils/const';
import { scanSpeed } from "../slots";

const { TabPane } = Tabs;

class GeneralPreviewSettingsComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scanType: this.props.preview.speed === scanSpeed.ZSTACK ? scanTypeVals.Z_STACK : scanTypeVals.WSI,
        }
    }

    componentDidUpdate = () => {
    }

    changeScanType = (key) => {
        if(key === scanTypeVals.Z_STACK){
            this.props.onScanSpeedChangeStack();
        }
        this.setState({
            scanType: key,
        });
    }
    

    render() {
        const slideKey = this.props.cassetteKey + "S" + this.props.id;
        // let is_superuser = cookie.loadAll().superuser === "true";
        let trayKey = this.props.cassetteKey;
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        return(
            <div>
                <Row style={{height: '100%'}}>
                    <Col span={24}>
                        <Row>
                            {getC240CanvasComponent(this.props.status, this.props.previewCanvasRef, this.props.thresholdCanvasRef,
                                this.props.brushEraserPrevCanvasRef, this.props.regions, this.props.onCanvasUpdate, this.props.allowPainting, this.props.startPainting, this.props.paintCanvas, 
                                this.props.stopPainting, this.props.dropDistanceCanvas, this.props.dropDistanceCanvasRef, this.props.focusPointsCanvas, 
                                this.props.focusPointsCanvasRef, this.props.preview, this.props.device_id, this.props.brushType,
                                this.props.showBrushOrEraserSize, rack, tray, this.props.id, this.props.slideType)}
                        </Row>
                        <Row>
                            <Col className="selected-area-component">
                                Selected Area : {this.props.regionArea} mm2
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col span={8} style={{marginTop:"40px"}}>
                        
                        <Col >                        
                            {getVerticalBrushPanel(this.props.brushType, this.props.brushSize, this.props.changeBrushType, this.props.movedBrushSizeSlider)}
                        </Col>
                        
                    </Col>
                    <Col span={8} style={{marginTop:"12px"}}>
                        <Row className="side-panel-section" style={{marginBottom:8}}>
                            <Col>
                                <span className="arial-font" style={{marginRight:10, fontSize:13}}><b>Slide Name</b></span>
                                <Spin spinning={this.props.reading_barcode} tip="Trying to Read Barcode...">
                                    <Input value={this.props.name}
                                        style={{width: 260}} onChange={this.props.onScanNameChange} />
                                </Spin>
                            </Col>
                        </Row>
                        <Row className="side-panel-section" style={{marginBottom:8}}>
                            <Col>
                                {getStainChooser(this.props.onSpecimenTypeChange, this.props.preview, this.props.specimen_type)}
                            </Col>
                        </Row>
                        {/* {is_superuser ?
                            <Row className="side-panel-section">
                                <Col span={24}>
                                    <br></br>
                                    <Row style={{fontSize:13}}>
                                        <Col span={24}>
                                            <Checkbox checked={this.props.preview.doTilingOnly} onChange={this.props.toggleTiling}>
                                                Do Tiling Only
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row style={{fontSize:13}}>
                                        <Col span={24}>
                                            <Checkbox checked={this.props.preview.doTilingAfterScan} onChange={this.props.toggleTilingAfterScan}>
                                                Do Tiling After Scan
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row> :
                            null
                        } */}
                    </Col>
                    <Col span={8}>
                        <Row className="side-panel-section" style={{marginBottom:8}}>
                            <Tabs activeKey={this.state.scanType} onChange={this.changeScanType} size="small">
                                <TabPane tab="WSI" key={scanTypeVals.WSI}>
                                    This will take a normal scan.
                                    <Col style={{ marginTop: '10px' }}>
                                    {
                                        getSpeedPanel(this.props.onScanSpeedChange, this.props.preview)
                                    }
                                    </Col>
                                    <Col style={{ marginTop: '10px' }}>{
                                        (this.props.preview || {}).speed === scanSpeed.FAST ? "Mostly Flat Tissue.": 
                                        (this.props.preview || {}).speed === scanSpeed.MEDIUM ? "Some Artifacts." : "Very Heavy Artifacts. Can Have Folds" }</Col>
                                </TabPane>
                                {/* {
                                is_superuser || (cookie.load('morpheus_setting') || {}).show_take_z_scan 
                                ?
                                    <TabPane tab="Z Scan" key={scanTypeVals.Z_STACK}>
                                        <Row key={0} style={{ padding: 10 }}>
                                            <Row style={{fontSize:13}}>
                                                <Col span={10} className="z-stack-scan-text">
                                                    Z Stack Levels
                                                </Col>
                                                <Col span={14}>
                                                    <Input className="z-stack-scan-input-field" value={this.props.preview.zStackLevels} 
                                                        placeholder={10} onChange={this.props.onZLevelsChange} />
                                                </Col>
                                            </Row>
                                            <Row style={{fontSize:13}}>
                                                <Col span={10} className="z-stack-scan-text">
                                                    Step Size (um)
                                                </Col>
                                                <Col span={14}>
                                                    <Input className="z-stack-scan-input-field" value={this.props.preview.stepSize} 
                                                        placeholder={0.5} onChange={this.props.onStepSizeChange} />
                                                </Col>
                                            </Row>
                                        </Row>
                                    </TabPane>
                                    : null
                                } */}
                            </Tabs>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        deviceStatus: state.deviceStatusReducer[ownProps.device_id]
    }
}

export default connect(mapStateToProps)(GeneralPreviewSettingsComp);